import { storybookReady, disableFieldPresentMarkers, mediaNotSmall, cumulativeOffset } from '../../../core/js/utils'
import slider from '../../basic/slider/slider'
import { loggedInPromise } from '../login/login'
import { initBrandPanels } from '../brand-panel/brand-panel'
import { initModalOpeners } from '../modal/modal'

let storybook, settings, element, listingHead, listingBody, listingSearch, listingCloseButton, listingFilter, form, filtersShown, instance
// let thronVideos

(async function () {
  storybook = await storybookReady()

  settings = storybook ? {
    lastPage: true,
    brandTitles: [
      'ALBERT THURSTON',
      'ALBERTO FASCIANI',
      'ALBERTO LUTI',
      'ALDEN NEW ENGLAND',
      'BABY&TAYLOR',
      'BARBA NAPOLI',
      'BARBARULO 1894 Napoli',
      'BARBATI',
      'BARBED',
      'BARBOUR',
      'ANTONIO BARBUTO',
      'BARKER BLACK',
      'BARKER ENGLAND',
      'BARONIO',
      'BARRETT'
    ],
    favouriteBrandCodes: [],
    debug: true
  } : (window.listing || {})

  element = document.querySelector('.Listing')
  if (!element) {
    return
  }

  listingHead = element.querySelector('.Listing__Head')
  listingBody = element.querySelector('.Listing__Body')
  listingSearch = element.querySelector('.Listing__Search ')
  listingFilter = element.querySelector('.Listing__Filter')
  listingCloseButton = listingSearch ? listingSearch.querySelector('.Listing__Close__Button') : null
  form = element.querySelector('form')
  // thronVideos = []

  disableFieldPresentMarkers(form)

  initAutocomplete()

  initFilters()

  if (!settings.lastPage) {
    initScroll()
    settings.debug && console.log('dispatchEvent scroll')
    document.dispatchEvent(new CustomEvent('scroll'))

    window.addEventListener('message', function(e) {
      var messageObj = e.data
      settings.debug && console.log('messageObj', messageObj)
      if (messageObj.listingNextPage) {
        document.dispatchEvent(new CustomEvent('scroll', {
          detail: {
            'listingNextPage': true
          }
        }))
      }
    })
  }

  initMobile()

  listingFilter && listingFilter.addEventListener('click', (event) => {
    if (event.target.matches('.Listing__Filters__Apply')) {
      disableSearchInput()
    }
  })

  document.addEventListener('toggleMap2', (event) => {
    element.querySelectorAll('.BrandPanel--MapShown').forEach(item => {
      if (item !== event.detail.panel) {
        item.classList.remove('BrandPanel--MapShown')
      }
    })

    if (event.detail.show) {
      element.classList.add('Listing--MapShown')
    } else {
      element.classList.remove('Listing--MapShown')
    }

    adjustHeadAndBody()
    setTimeout(() => {
      let panelTop = event.detail.panel.offsetTop
      let headerHeight = document.querySelector('.Header').offsetHeight
      let headHeight = listingHead.offsetHeight
      window.scrollTo(0, panelTop - headerHeight - headHeight)
    }, 200)
  })

  initElement()

  initIframe()

  document.addEventListener('loggedIn', (event) => {
    favourites(location.pathname)
  })

  !storybook && brandTitles(location.pathname)
})()

function disableSearchInput () {
  form.querySelectorAll('.Listing__Search [type="text"]').forEach(element => {
    element.setAttribute('disabled', true)
  })
}

function disableAllButSearchInput () {
  form.querySelectorAll([
    '.Listing__Wishlist [type="checkbox"]',
    '.Listing__Initials [type="radio"]',
    '.Listing__Input__Hidden[type="hidden"]',
    '.Listing__AppliedFilters [type="checkbox"]'
  ].join()).forEach(element => {
    element.setAttribute('disabled', true)
  })
}

async function initAutocomplete () {
  if (settings.iframe) {
    return
  }

  let q = form.querySelector('.Listing__Search [type="text"]')

  if (q) {
    let qValue = q.value.toUpperCase()

    let keyupIterator = events(q, 'keyup', () => {
      let previous = qValue
      qValue = q.value.toUpperCase()
      let changed = (qValue !== previous)
      return changed
    })

    listingCloseButton && listingCloseButton.addEventListener('click', () => {
      instance && instance.hide()
      listingSearch && listingSearch.removeAttribute('data-typing')
      if (q) {
        q.value = ''
      }
      if (!storybook) {
        disableAllButSearchInput()
        form && form.submit()
      }
    })

    q.addEventListener('keypress', function (e) {
      var key = e.which || e.keyCode
      if (key === 13) { // 13 is enter
        //          '.Listing__Search [type="text"] + a'
        disableAllButSearchInput()
      }
    })
    while (true) {
      let next = await keyupIterator.next()
      let titles = (qValue.length >= 3) && settings.brandTitles.filter(title => (title.indexOf(qValue) >= 0))
      let show = (titles && titles.length)

      instance = q._tippy

      if (qValue) {
        listingSearch && listingSearch.setAttribute('data-typing', true)
      } else {
        listingSearch && listingSearch.removeAttribute('data-typing')
      }

      if (show) {
        if (!instance) {
          instance = tippy(q, {
            trigger: 'manual',
            theme: 'pitti',
            arrow: true,
            hideOnClick: false,
            interactive: true,
            size: 'large',
            distance: 10,
            appendTo: 'parent',
            placement: 'bottom',
            flip: false
          })
        }
        let content = document.createElement('ul')
        content.classList.add('Listing__Search__Suggestions')
        content.innerHTML = titles.map(title => ('<li>' + title + '</li>')).join('')
        content.querySelectorAll('li').forEach(item => {
          item.addEventListener('click', function () {
            q.value = this.innerHTML.replace(/&amp;/g, '&')
            instance.hide()
            if (!storybook) {
              disableAllButSearchInput()

              // Google Analytics
              // form.submit()
              let button = listingSearch.querySelector('button')
              button.dataset.galabel = q.value
              button.click()
            }
          })
        })
        instance.setContent(content)
        instance.show()
      } else {
        instance && instance.hide()
      }
    }
  }
}

function initFilters () {

  const applyFilter = (trigger) => {
    settings.debug && console.log('applyFilter', trigger, trigger.checked, trigger.parentNode.classList)
    if (trigger.parentNode.classList.contains('Listing__Initials__Item')) {
      if (trigger.checked && trigger.parentNode.classList.contains('active')) {
        trigger.checked = false
        trigger.parentNode.classList.remove('active')
      } else {
        form.querySelectorAll('.Listing__Initials__Item.active').forEach(activeItem => activeItem.classList.remove('active'))
        trigger.parentNode.classList.add('active')
      }
    }
    if (!storybook) {
      disableSearchInput()
      setTimeout(() => { form.submit() }, 200)
    }
  }

  const filterClick = (event) => {
    let trigger = event.currentTarget
    if (trigger.closest('.Listing__Wishlist')) {
      loggedInPromise().then(response => {
        if (response) {
          applyFilter(trigger)
        }
      })
    } else {
      applyFilter(trigger)
    }
  }

  if (settings.iframe) {
    form.querySelectorAll('.Listing__Initials [type="radio"]').forEach(item => {
      item.removeEventListener('click', filterClick)
      item.addEventListener('click', filterClick)
    })
    return
  }

  !settings.editMode && fetch(location.pathname + '?filters=true' + location.search.replace(/^\?/, '&'), {
    credentials: 'same-origin',
    method: 'GET',
    headers: {
      Accept: 'text/html'
    }
  })
  .then(response => {
    if (response.status === 200) {
      return response.text()
    } else {
      throw new Error("Not 200 response")
    }
  })
  .then(text => {
    let row1 = listingHead.querySelector('.Listing__Head__Row1')
    row1.insertAdjacentHTML('afterend', text.replace(/<form.*?>|<\/form>/, ''))
    adjustHeadAndBody()

    form.querySelectorAll([
      '.Listing__Display [type="radio"]',
      '.Listing__Search [type="text"] + a',
      '.Listing__Wishlist [type="checkbox"]',
      '.Listing__Initials [type="radio"]',
      '.Listing__Input__Hidden[type="hidden"]',
      '.Listing__AppliedFilters [type="checkbox"]'
    ].join()).forEach(item => {
      item.removeEventListener('click', filterClick)
      item.addEventListener('click', filterClick)
    })

    window.initTracking && window.initTracking(form)
  })

  let small = !mediaNotSmall()

  function buildFromTemplate (id) {
    const template = document.getElementById(id)
    const node = document.importNode(template.content, true)
    const container = document.createElement('div')
    container.appendChild(node)
    return container
  }

  function initContent (container) {
    disableFieldPresentMarkers(container)

    container.querySelectorAll('.Listing__Filters__Top [type="checkbox"]').forEach(item => {
      item.addEventListener('click', function () {
        if (storybook) {
          return
        }
        disableSearchInput()
        form.submit()
      })
    })

    let tabs = container.querySelectorAll('.Listing__Filters__Tab')
    tabs.forEach(item => {
      item.addEventListener('click', (event) => {
        event.preventDefault()
        selectTab(tabs, item)
      })
    })

    let enableButtons = () => {
      container.querySelectorAll('.Listing__Filters__Buttons .Button').forEach(item => {
        item.removeAttribute('disabled')
      })
    }
    container.querySelectorAll('.Listing__Filters__TabPanel [type="checkbox"][value]').forEach(item => {
      item.addEventListener('click', function () {
        enableButtons()

        fetch(location.pathname + '?filters=true' + new URLSearchParams(new FormData(form)).toString(), {
          credentials: 'same-origin',
          method: 'GET',
          headers: {
            Accept: 'text/html'
          }
        })
        .then(response => {
          if (response.status === 200) {
            return response.text()
          } else {
            throw new Error("Not 200 response")
          }
        })
        .then(text => {
          let filters = container.querySelector('.Listing__Filters')
          let activeHref = filters.querySelector('.Listing__Filters__Tab.active').getAttribute('href')
          let currentCard = item.closest('.Accordion__Card')
          let currentCardId = currentCard && currentCard.firstElementChild.id
          filters.outerHTML = text.replace(/[\s\S]*<template.*?>/m, '').replace(/<\/template>[\s\S]*/m, '')
          initContent(container)
          activeHref && container.querySelector('.Listing__Filters__Tab[href="' + activeHref + '"]')
              .dispatchEvent(new MouseEvent('click', { view: window, bubbles: true, cancelable: true }))
          currentCardId && container.querySelector('#' + currentCardId)
              .dispatchEvent(new MouseEvent('click', { view: window, bubbles: true, cancelable: true }))
          enableButtons()
        })
      })
    })

    /*
    let inputs = container.querySelectorAll('.Listing__Filters__TabPanel--Accordion .Accordion__Card > [type="checkbox"]')
    inputs.forEach(item => {
      item.addEventListener('click', function () {
        settings.debug && console.log('click')
        inputs.forEach(item2 => {
          item2.checked = (item2 === item)
        })

        if (mediaNotSmall()) {
          fixScrollbar(container.closest('.tippy-popper'))
        }
      })
    })*/

    window.initTracking && window.initTracking(container)
  }

  if (small) {
    document.querySelector('[data-filters]') && document.querySelector('[data-filters]').addEventListener('click', (event) => {
      event.preventDefault()
      let filters = listingHead.querySelector('.Listing__Filters')
      if (!filters) {
        let container = buildFromTemplate('listingFilters')
        let row1 = listingHead.querySelector('.Listing__Head__Row1')
        row1.parentNode.insertBefore(container, row1.nextSibling)
        initContent(container)
        element.classList.add('Listing--FiltersShown')
        adjustHeadAndBody()
      } else {
        filters.parentNode.remove()
        element.classList.remove('Listing--FiltersShown')
        adjustHeadAndBody()
      }
    })

    return
  }

  function fixedWidth (data) {
    data.offsets.popper.left = 0
    data.styles.width = document.documentElement.clientWidth
    data.styles.maxWidth = document.documentElement.clientWidth
    return data
  }

  tippy('[data-filters]', {
    trigger: 'click',
    theme: 'pitti',
    arrow: true,
    hideOnClick: 'toggle',
    interactive: true,
    size: 'large',
    distance: 15,
    maxWidth: 'none',
    onShown (instance) {
      let container = instance.popper
      if (!container.querySelector('.Listing__Filters') && document.getElementById('listingFilters')) {
        container = buildFromTemplate('listingFilters')
        initContent(container)
        instance.setContent(container)
      }
      element.querySelectorAll('.Listing__AppliedFilters input').forEach(item => {
        item.disabled = true
      })
      element.classList.add('Listing--FiltersShown')
      filtersShown = true
    },
    onHidden (instance) {
      const container = instance.popper
      container.querySelectorAll([
        '.Listing__Filters__TabPanel',
        '.Listing__Filters__Buttons'].join()).forEach(item => {
        item.style.display = 'none'
      })

      element.querySelectorAll('.Listing__AppliedFilters input').forEach(item => {
        item.disabled = false
      })

      filtersShown = false
      instance.reference.blur()

      element.classList.remove('Listing--FiltersShown')
      listingBody.style.height = ''
    },
    appendTo: 'parent',
    placement: 'bottom-end',
    popperOptions: {
      modifiers: {
        fixedWidth: {
          enabled: true,
          fn: fixedWidth,
          order: 840
        }
      }
    },
    sticky: true,
    flipOnUpdate: false
  })
}

async function initScroll () {
  settings.debug && console.log('initScroll')

  let scrollIterator = events(document, 'scroll', (event) => {
    let windowY = (window.pageYOffset + window.innerHeight)
    let elementY = (element.offsetTop + element.clientHeight)
    let force = (event.detail && event.detail.listingNextPage)
    let condition = (windowY > elementY - 10) || force
    settings.debug && console.log('scroll force ' + force + ' condition ' + condition)
    condition &= !filtersShown
    return condition
  })
  let pageIterator = pages()

  while (true) {
    settings.debug && console.log('wait for scroll')
    await scrollIterator.next()
    settings.debug && console.log('fulfilled scroll')

    element.querySelector('.Loading').style.display = ''
    settings.debug && console.log('wait for page')
    let next = await pageIterator.next()
    settings.debug && console.log('fulfilled page')
    element.querySelector('.Loading').style.display = 'none'

    if (next.done) {
      break
    }

    let data = next.value
    if (typeof data === 'object') {
      let groups = []
      let previous
      data && data.forEach(brand => {
        let group
        if (!previous || (brand.initial !== previous.initial)) {
          group = []
          groups.push(group)
        } else {
          group = groups[groups.length - 1]
        }
        group.push(brand)
        previous = brand
      })
      // console.log('groups', groups)

      groups.forEach(group => {
        let bodyText = group.map(itemText).join('')
        // console.log('bodyText', bodyText)
        let groupBody = element.querySelector(`.Listing__Group[data-initial="${group[0].initial}"] .Listing__Group__Body`)
        if (groupBody) {
          groupBody.insertAdjacentHTML('beforeend', bodyText)
        } else {
          let groupText = `
<div class="Listing__Group" data-initial="${group[0].initial}">
  <div class="Listing__Group__Head">${group[0].initialText}</div>
  <div class="Listing__Group__Body">${bodyText}</div>
</div>`
          element.querySelector('.Listing__Body').insertAdjacentHTML('beforeend', groupText)
        }
      })

      // see initElement removeEmptyData
      // removing all Where_Are_we se senza "location"
      // var toDeleteArray = []
      // document.querySelectorAll('.Where_Are_we p').forEach(thisp => { if (thisp.firstChild.textContent.trim() == '/  /') toDeleteArray.push(thisp) })
      // toDeleteArray.forEach(thiselement => thiselement.parentNode.remove())

      initElement()
      initBrandPanels(element)
      window.initTracking && window.initTracking(element)

      // thronVideos.forEach(item => {
      //   window.initThronVideo && window.initThronVideo(item)
      // })
      // thronVideos.length = 0

    } else if (typeof data === 'string') {
      element.querySelector('.Listing__Body').insertAdjacentHTML('beforeend', data)
    }
    sendListingHeight()
  }

}

async function* events (el, name, condition) {
  let resolve
  el.addEventListener(name, e => {
    if (condition(e)) {
      resolve(e)
    }
  })
  while (true) {
    yield await new Promise(_resolve => resolve = _resolve)
  }
}

async function* pages () {
  let pageNum = 1
  let content
  do {
    settings.debug && console.log('wait for content')
    content = await fetchPage(++pageNum, 'application/json')
    // content = await fetchPage(++pageNum, 'text/html')
    settings.debug && console.log('fulfilled content')
    yield content.data
  } while (!content.last)
}

function fetchPage (pageNum, mediaType) {
  return new Promise((resolve) => {
    let query = 'fetchpage=true&' + new URLSearchParams(new FormData(form)).toString() + '&page=' + pageNum
    let last
    fetch(location.pathname + '?' + query, {
      credentials: 'same-origin',
      method: 'GET',
      headers: {
        Accept: mediaType
      }
    })
      .then(response => {
        if (response.status === 200) {
          if (response.headers.get('Content-Type').indexOf('application/json') !== -1) {
            return response.json()
          } else {
            last = (response.headers.get('LastPage') === 'true')
            return response.text()
          }
        } else {
          throw new Error('Not 200 response')
        }
      })
      .then(data => {
        if (typeof data === 'object') {
          last = data.last
          data = data.brands
        }
        resolve({
          'data': data,
          'last': last
        })
      })
      .catch(function (err) {
      })
  })
}

function itemText (brand) {
  let text = brand && document.getElementById('listingItem').innerHTML
      .replace(/\$code\$/g, brand.code)
      .replace(/\$title\$/g, brand.link && brand.link.text)

  if (listingBody.classList.contains('Listing__Body--List')) {
    if (brand.link && brand.link.url) {
      text = text.replace(/\$link\$/g, brand.link.url)
    } else {
      text = text.replace(/<a(\s+.*?)href="\$link\$"([\s\S]*?)<\/a>/m, '<span$1$2</span>')
    }
  } else {
    if (window.listing.favouriteBrandCodes && window.listing.favouriteBrandCodes.indexOf(brand.code) >= 0) {
      text = text.replace(/(data-brand=".*?")/, '$1 data-favourite')
          .replace(/data-tracking="add-favourite"/, 'data-tracking="remove-favourite"')
    }
    text = text.replace(/\$country\$/g, brand.country)
      .replace(/\$logoUrl\$/g, brand.logo && brand.logo.url)
      .replace(/\$styles\$/g, (brand.styleTexts || []).join(', '))
      .replace(/\$location\$/g, brand.location || '')

    if (brand.link && brand.link.url) {
      text = text.replace(/\$link\$/g, brand.link.url)
      text = text.replace(/\$target\$/g, brand.link.target)
    } else {
      text = text.replace(/<a(\s+.*?)href="\$link\$"([\s\S]*?)<\/a>/m, '<div$1$2</div>')
          .replace(/BrandPanel--Link/g, '')
          .replace(/<svg\s+.*?"discoverTheBrand"[\s\S]*?<\/span>/m, '')
          .replace(/<a\s+.*?"Map2__Tooltip"[\s\S]*?<\/a>/m, '')
    }

    if (brand.websiteLink && brand.websiteLink.url) {
      text = text.replace(/\$websiteUrl\$/g, brand.websiteLink.url)
      text = text.replace(/\$websiteTarget\$/g, brand.websiteLink.target)
      text = text.replace(/\$websiteText\$/g, brand.websiteLink.text)
    } else {
      text = text.replace(/<a(\s+.*?)href="\$websiteUrl\$"([\s\S]*?)<\/a>/m, '')
    }

    if (brand.heroImage) {
      text = text.replace('$heroImageUrl$', brand.heroImage.url)
    } else {
      text = text.replace(/<div\s+.*?"imageContainer">[\s\S]*?<\/div>/m, '')
    }

    if (brand.videoHeroPanelId) {
      text = text.replace(/\$videoHeroModalOpener\$/g, brand.videoHeroModalOpener)
          .replace('$videoHeroGaLabel$', brand.videoHeroGaLabel)
          .replace('$videoPanelId$', brand.videoHeroPanelId)
          .replace('$videoPanelHeight$', brand.videoHeroPanelHeight)

      let uniqueId = brand.videoHeroPanelId.replace(/^videoPanel/, '')
      settings.debug && console.log('uniqueId', uniqueId)
      window.thron = window.thron || {}
      window.thron[uniqueId] = {
        autoPlay: false,
        poster: brand.videoHeroPoster,
        bufferTime: 2,
        displayLinked: 'none',
        displayDownload: 'none'
      }
      // thronVideos.push(uniqueId)

      if (brand.videoHeroImage) {
        text = text.replace('$videoHeroImageUrl$', brand.videoHeroImage.url)
      }
    } else {
      text = text.replace(/<div\s+.*?"imageContainer"\s+data-modal_opener=[\s\S]*?<\/div>/m, '')
      // text = text.replace(/<div\s+.*?"modal-content"[\s\S]*?<\/div>/m, '')
    }
  }
  return text
}

function initMobile () {
  settings.debug && console.log('initMobile')

  let initials = element.querySelector('.Listing__Initials')

  let documentScrollListener = () => {
    let groups = element.querySelectorAll('.Listing__Group')
    if (!groups.length) {
      return
    }
    let top = window.pageYOffset + groups[0].offsetTop
    let group = Array.from(groups).find(item => {
      return ((item.offsetTop + item.clientHeight) > top)
    })
    if (!group) {
      group = groups[groups.length - 1]
    }
    initials.querySelectorAll('.Listing__Initials__Item').forEach(item => {
      let radio = item.querySelector('input[type="radio"]')
      if (radio && radio.value === group.dataset.initial) {
        item.classList.add('active')
        setTimeout(() => {
          settings.debug && console.log(initials.offsetWidth, item.offsetLeft, item.offsetWidth)
          initials.scroll(item.offsetLeft - (initials.offsetWidth - item.offsetWidth) / 2, 0)
        }, 0)
      } else {
        item.classList.remove('active')
      }
    })
  }

  let leftSide, rightSide
  let leftWidth, rightWidth
  let swapped = false
  let busy = false

  let initialsScrollListener = () => {
    if (busy) {
      return
    }
    if (!leftSide) {
      leftSide = Array.from(initials.querySelectorAll('.Listing__Initials__Item'))
      rightSide = leftSide.splice(Math.floor(leftSide.length / 2))

      leftWidth = leftSide.reduce((acc, cur) => acc + cur.offsetWidth, 0)
      rightWidth = rightSide.reduce((acc, cur) => acc + cur.offsetWidth, 0)
    }
    settings.debug && console.log(initials.scrollLeft, leftWidth, rightWidth, swapped)
    let scrollLeft = initials.scrollLeft
    if (!swapped) {
      if (scrollLeft < 10 || (scrollLeft + initials.offsetWidth) > (leftWidth + rightWidth - 10)) {
        settings.debug && console.log('swap')
        busy = true
        let firstChild = initials.childNodes[0]
        rightSide.forEach(item => {
          initials.insertBefore(item, firstChild)
        })
        swapped = true
        initials.scroll((scrollLeft < 10) ? (scrollLeft + rightWidth) : (scrollLeft - leftWidth - rightWidth), 0)
        busy = false
      }
    } else {
      if (scrollLeft < 10 || scrollLeft > (rightWidth + 10)) {
        settings.debug && console.log('swap back')
        busy = true
        let firstChild = initials.childNodes[0]
        leftSide.forEach(item => {
          initials.insertBefore(item, firstChild)
        })
        swapped = false
        initials.scroll((scrollLeft < 10) ? (scrollLeft + leftWidth) : (scrollLeft - rightWidth), 0)
        busy = false
      }
    }
  }

  let resizeListener = () => {

    settings.debug && console.log('resizeListener')
    adjustHeadAndBody()

    let small = !mediaNotSmall()
    if (small) {
      document.addEventListener('scroll', documentScrollListener)
      initials.addEventListener('scroll', initialsScrollListener)

      documentScrollListener()
      initialsScrollListener()
    } else {
      document.removeEventListener('scroll', documentScrollListener)
      initials.removeEventListener('scroll', initialsScrollListener)
    }
  }
  window.addEventListener('resize', resizeListener)
  resizeListener()
}

function initElement () {
  // PITTIECO-475 PITTIECO-493
  // balanceColumns()

  removeEmptyData()

  // initModalOpeners(element)
}

function sendListingHeight() {
  parent.postMessage({
    listingHeight: element.scrollHeight
  }, '*')
}

function initIframe () {
  if (!settings.iframe) {
    return
  }

  if (element && element.hasAttribute('data-iframe') && parent) {
    window.addEventListener('resize', sendListingHeight)
    document.addEventListener('DOMContentLoaded', sendListingHeight)
  }
}

function adjustHeadAndBody () {
  let header = document.querySelector('.Header')
  let top = (header ? header.offsetHeight + 'px' : 0)
  listingHead.style.top = top

  let marginTop = (listingHead && !element.classList.contains('Listing--FiltersShown'))
    ? listingHead.offsetHeight + 'px'
    : 0
  listingBody.style.marginTop = marginTop

  settings.debug && console.log('adjustHeadAndBody', top, marginTop)
}

function selectTab (tabs, tab) {
  let small = !mediaNotSmall()

  tabs.forEach(tab2 => {
    (tab2 === tab) ? tab2.classList.add('active') : tab2.classList.remove('active')
  })

  let container = tab.closest('.Listing__Filters')
  container.querySelectorAll('.Listing__Filters__TabPanel').forEach(panel => {
    let display = ('#' + panel.id === tab.hash)
    panel.style.display = display ? '' : 'none'

    if (display) {
      showAndRepositionButtons(container)

      panel.querySelectorAll('.glide').forEach(glide => {
        slider(glide)

        if (!small) {
          let count = glide.querySelectorAll('.glide__slide').length
          glide.querySelector('.glide__arrows').style.display = (count > 3) ? '' : 'none'
        }
      })
    }
  })

  if (!small) {
    fixScrollbar(container.closest('.tippy-popper'))
  }
}

function showAndRepositionButtons (container) {
  let buttons = container.querySelector('.Listing__Filters__Buttons')
  buttons.style.display = ''

  if (mediaNotSmall()) {
    let scroll = container.querySelector('.Listing__Filters__Scroll')
    scroll.style.height = ''

    setTimeout(() => {
      let windowY = (window.scrollY + window.innerHeight)
      let buttonsY = cumulativeOffset(buttons).top + buttons.clientHeight
      let overflowY = (buttonsY - windowY) + 142
      settings.debug && console.log('showAndRepositionButtons', buttonsY, windowY, overflowY)

      if (overflowY > 0) {
        let scrollHeight = scroll.clientHeight

        let height = scrollHeight - overflowY
        settings.debug && console.log('showAndRepositionButtons', overflowY, scrollHeight, height)
        if (height >= 40) {
          scroll.style.height = height + 'px'
        }
      }
    }, 100)
  }
}

function favourites (pathname) {
  fetch(pathname + '?favourites=true', {
    credentials: 'same-origin',
    method: 'GET',
    headers: {
      Accept: 'application/json'
    }
  })
    .then(response => {
      if (response.status === 200) {
        return response.json()
      } else {
        throw new Error('Not 200 response')
      }
    })
    .then(json => {
      window.listing.favouriteBrandCodes = json
      json.forEach((item) => {
        let brandPanel = element.querySelector(`.BrandPanel[data-brand="${item}"]`)
        if (brandPanel) {
          brandPanel.dataset.favourite = ''
        }
      })
    })
}

function fixScrollbar (tippyPopper) {
  let height = tippyPopper.clientHeight
  settings.debug && console.log('fixScrollbar', height)
  listingBody.style.height = height + 'px'
}

/* PITTIECO-475 PITTIECO-493
function balanceColumns() {
  settings.debug && console.log('balanceColumns')
  if (!mediaNotSmall() || !listingBody.classList.contains('Listing__Body--List')) {
    return
  }
  listingBody.querySelectorAll('.Listing__Group__Body').forEach(group => {
    fixColumns(group, true)
  })
}

function fixColumns(group, check) {
  let items = group.querySelectorAll('.Listing__Item:not(.Listing__Item--Fake)')

  let length = items.length
  if (!length) {
    return true
  }

  let actual = actualColumns(length)
  let desired = desiredColumns(length)

  settings.debug && console.log('length', length)
  settings.debug && console.log('actual', actual)
  settings.debug && console.log('desired', desired)

  let expected = 0

  if (actual[1] > desired[1]) {
    insertFakeListingItemBefore(items[desired[0] + desired[1]])
    actual[2]++
    expected++
  }

  if (actual[2] > desired[2]) {
    insertFakeListingItemBefore(items[desired[0] + desired[1] + desired[2]])
    expected++
  }

  if (check) {
    let items2 = group.querySelectorAll('.Listing__Item--Fake')
    let length2 = items2.length
    if (length2 !== expected) {
      items2.forEach(item => {
        item.remove()
      })
      fixColumns(group, false)
    }
  }
}

function actualColumns(length) {
  let count1 = Math.floor((length - 1) / 4) + 1
  let count2 = (length - count1) >= count1 ? count1 : (length - count1)
  let count3 = (length - count1 - count2) >= count1 ? count1 : (length - count1 - count2)
  let count4 = (length - count1 - count2 - count3) >= count1 ? count1 : (length - count1 - count2 - count3)
  return [ count1, count2, count3, count4 ]
}

function desiredColumns(length) {
  let count1 = Math.floor((length - 1) / 4) + 1
  let count2 = Math.floor(((length - count1) - 1) / 3) + 1
  let count3 = Math.floor(((length - count1 - count2) - 1) / 2) + 1
  let count4 = length - count1 - count2 - count3
  return [ count1, count2, count3, count4 ]
}

function insertFakeListingItemBefore(item) {
  if (item.previousElementSibling && item.previousElementSibling.classList.contains('Listing__Item--Fake')) {
    return
  }
  let fake = document.createElement('div')
  fake.classList.add('Listing__Item')
  fake.classList.add('Listing__Item--Fake')
  fake.innerHTML = '<span>&nbsp;</span>'
  item.parentNode.insertBefore(fake, item)
}
*/

function removeEmptyData() {
  settings.debug && console.log('removeEmptyData')
  if (!listingBody.classList.contains('Listing__Body--Band')) {
    return
  }
  Array.from(listingBody.querySelectorAll('.BrandPanel__List li')).filter(item => {
    return Array.from(item.querySelectorAll('p')).every(item2 => {
      return !item2.innerText.trim().length
    })
  }).forEach(item => item.remove())
}

function brandTitles (pathname) {
  fetch(pathname + '?brandtitles=true', {
    credentials: 'same-origin',
    method: 'GET',
    headers: {
      Accept: 'application/json'
    }
  })
    .then(response => {
      if (response.status === 200) {
        return response.json()
      } else {
        throw new Error('Not 200 response')
      }
    })
    .then(json => {
      settings.brandTitles = json
    })
}
